import React from "react";

type ProgressControlsProps = {
  canGoBack: boolean;
  canGoNext: boolean;
  currentPosition: number;
  totalScenes: number;
  onBack: () => void;
  onNext: () => void;
  onRestart: () => void;
};

export function ProgressControls({
  canGoBack,
  canGoNext,
  currentPosition,
  totalScenes,
  onBack,
  onNext,
  onRestart,
}: ProgressControlsProps) {
  return (
    <div className="story-controls" aria-label="Story controls">
      <button
        className="story-control-button"
        type="button"
        onClick={onBack}
        disabled={!canGoBack}
      >
        Previous
      </button>
      <div className="story-progress" aria-live="polite">
        {currentPosition} / {totalScenes}
      </div>
      <button className="story-control-button" type="button" onClick={onRestart}>
        Restart
      </button>
      <button
        className="story-control-button"
        type="button"
        onClick={onNext}
        disabled={!canGoNext}
      >
        Next
      </button>
    </div>
  );
}
